// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isOAuthAuthorizedResult = objectOf({
  code: string,
  state: anyOf(string, nullValidation),
});
